import {
  RESET_INVITATION_FORM,
  SUBMIT_INVITATION,
} from '../actions/InviteActionCreator';
import Immutable from 'immutable';

const defaultState = Immutable.fromJS({
  inviteFormStatus: 'default',
});

export function invite(state = defaultState, action = null) {
  switch (action.type) {
    case SUBMIT_INVITATION: {
      return state.set('inviteFormStatus', action.status);
    }
    case RESET_INVITATION_FORM: {
      return state.set('inviteFormStatus', 'default');
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/invite.js